module.exports = __webpack_public_path__ + "static/media/image_36.dbc2a14b.png";